import { Button, Space } from "antd";
import { useNavigate } from "react-router-dom";

export default function NotFoundActions({ homePath = "/" }) {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(homePath, { replace: true });
    }
  };

  return (
    <Space wrap size="middle" style={{ marginBottom: 24 }}>
      <Button size="large" onClick={goBack}>
        Go back
      </Button>
      <Button type="primary" size="large" href={homePath}>
        Back to home
      </Button>
    </Space>
  );
}
